




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import AnonBookingRoleWorkerDto from '@/models/AnonBookingRoleWorkers/AnonBookingRoleWorkerDto';
import UpdateAnonWorkerBookingConfirmationRequest from '@/models/AnonBookingRoleWorkers/UpdateAnonWorkerBookingConfirmationRequest';
import PageNames from '@/router/PageNames';
import AnonBookedReplyViewModel from '@/models/AnonBookingRoleWorkers/AnonBookedReplyViewModel';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ShiftDeclinedReason from '@/models/Shared/ShiftDeclinedReason';
import AnonBookedReply from '@/models/AnonBookingRoleWorkers/AnonBookedReplyDto';
import AnonBookedReplyDto from '@/models/AnonBookingRoleWorkers/AnonBookedReplyDto';
import BookingRoleWorkerShiftStatus from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';

@Component({
    name: 'WorkerBookingOfferApplyDecline'
})
export default class extends GiganautVueDialog {

  public dialog = false;
  public shifts: AnonBookedReplyViewModel[] = [];

  get allowDeclineBooking () {
      return WorkerAnonModule.bookingConfirmation.allowDeclineBooking;
  }

  get buttonLabel() {
    if (this.allowDeclineBooking) {
      return "CONFIRM/DECLINE";
    } else {
      return "CONFIRM";
    }    
  }

  get dialogTitle() {
    if (this.allowDeclineBooking) {
      return "Confirm or Decline Shifts";
    } else {
      return "Confirm Shifts";
    }    
  }

  get submitButtonLabel() {
    if (this.allowDeclineBooking) {
      return "SUBMIT";
    } else {
      return "CONFIRM";
    }   
  }

  get bookingConfirmation() {
    return WorkerAnonModule.bookingConfirmation;
  }
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      //Remove the shifts that have alreay been confirmed if any
      const unconfirmedShifts = WorkerAnonModule.bookingConfirmation.shifts.filter(shift => shift.status === BookingRoleWorkerShiftStatus.BookedUnconfirmed)
      this.shifts =  unconfirmedShifts.map(function(anonShiftSummaryDto) {
        const shiftVM = new AnonBookedReplyViewModel();
        shiftVM.bookingRoleWorkerShiftId = anonShiftSummaryDto.bookingRoleWorkerShiftId;
        shiftVM.startAt = anonShiftSummaryDto.startAt;
        shiftVM.endAt = anonShiftSummaryDto.endAt;
        return shiftVM;
      });
    }
  }

  get loading() {
    return WorkerAnonModule.loadingDialog;
  }

  get declinedReasons() {
    return ListUtils.shiftDeclinedReasons();
  }
	  
  async submit() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAnonWorkerBookingConfirmationRequest();
    const allowDeclineBookingLocal = this.allowDeclineBooking;
    request.updatedAt = WorkerAnonModule.bookingOffer.updatedAt
    request.replies = this.shifts.map(function(vm: AnonBookedReplyViewModel) {
      const reply: AnonBookedReplyDto = new AnonBookedReplyDto();
      reply.bookingRoleWorkerShiftId = vm.bookingRoleWorkerShiftId;
      if (allowDeclineBookingLocal) {
        reply.confirmed = vm.confirm;
        if (reply.confirmed) {
          reply.declinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
        } else {
          reply.declinedReason = vm.declinedReason;
        }
      } else {
        reply.confirmed = true;
        reply.declinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
      }
      return reply;
    });
    await WorkerAnonModule.updateBookingConfirmation(request);
    this.dialog = false;
    if (WorkerAnonModule.isError) {
       this.$router.push({ name: PageNames.WorkerError });
    }
  }
}
